import { Injectable } from '@angular/core';

const SOCIAL_DATA_KEY = 'social_data';

/**
 * Service that uses browser localStorage as a storage.
 */
@Injectable({
  providedIn: 'root',
})
export class SocialStorageService {
  /**
   * Returns social user from localStorage
   * @returns SocialUser
   */
  static get(): any {
    return JSON.parse(localStorage.getItem(SOCIAL_DATA_KEY)) as any;
  }

  /**
   * Sets social user to localStorage
   * @param user
   */
  static set(user: any): void {
    const str = JSON.stringify(user);

    if (!str) {
      return;
    }

    localStorage.setItem(SOCIAL_DATA_KEY, str);
  }

  /**
   * Clears social user from localStorage
   */
  static clear(): void {
    localStorage.removeItem(SOCIAL_DATA_KEY);
  }
}
